<template>
  <div class="auth-layout min-h-screen bg-white">

    <img :src="bannerImage" alt="Bienvenido a la nueva plataforma ADS Solutions" class="auth-banner" />

    <div class="auth-panel flex flex-col items-center justify-center-safe px-8 py-8">
      <div class="flex flex-col items-center w-full max-w-xs gap-6">
        <img src="@/assets/img/ads_logo_2.png" alt="Logo" class="w-28">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import bannerImage from '@/assets/img/bg_login_ads.webp';
</script>

<style scoped>
/* Por defecto (móvil, tablet en vertical) el banner va arriba a todo el ancho y el panel debajo. */
.auth-layout {
  display: flex;
  flex-direction: column;
}

.auth-banner {
  width: 100%;
  height: auto;
}

/* Campos sin error: sin el hueco que InputPrimary reserva para el mensaje quedan juntos como en el diseño. */
.auth-panel :deep(.container) {
  margin: 0;
}

.auth-panel :deep(.container > p:empty) {
  display: none;
}

/*
 * Banner a la izquierda a toda altura, recortado por la derecha. Solo cuando cabe entero el bloque
 * de texto del banner (unos 760 px de sus 1729 de ancho): en 1024x768 con el panel de 380 px quedan 763.
 */
@media (min-width: 1024px) and (min-aspect-ratio: 4/3) {
  .auth-layout {
    flex-direction: row;
    height: 100vh;
  }

  .auth-banner {
    flex: 1;
    min-width: 0;
    height: 100%;
    object-fit: cover;
    object-position: left center;
  }

  .auth-panel {
    width: 380px;
    flex-shrink: 0;
    overflow-y: auto;
  }
}

@media (min-width: 1280px) and (min-aspect-ratio: 4/3) {
  .auth-panel {
    width: 420px;
  }
}
</style>
